<template>
    <client-page>
        <v-sheet max-width="480" class="mx-auto">
            <v-card-title class="justify-center text-h3 font-weight-bold"> {{ userTypeText }} 회원가입 </v-card-title>
            <v-card-text> <join-form v-bind="{ code, skin: code }" /> </v-card-text>
        </v-sheet>
    </client-page>
</template>

<script>
import { USER_TYPES } from "@/assets/variables";

import JoinForm from "@/components/client/join/join-form.vue";
import ClientPage from "@/pages/client/templates/ClientPage.vue";

export default {
    components: {
        JoinForm,
        ClientPage,
    },
    computed: {
        code() {
            return this.$route.query.code || USER_TYPES.PERSON.value;
        },
        userTypeText() {
            return USER_TYPES[this.code]?.text;
        },
    },
};
</script>
